import { MultipleItemResponse, SingleItemResponse, fetchContent } from './fetchContent'

type Args = {
  language: string
  urlSlug: string
  preview?: boolean
}

export const getPageByUrlSlug = async <Model>({
  language,
  urlSlug,
  preview,
}: Args): Promise<SingleItemResponse<Model> | null> => {
  const response: MultipleItemResponse<Model> = await fetchContent({
    path: '',
    preview,
    params: {
      language: language || 'en',
      limit: 1,
      'elements.url_slug': urlSlug,
    },
  })

  if (response.pagination.count === 0) {
    return null
  }

  return {
    item: response.items[0],
    modular_content: response.modular_content,
  }
}
